import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getCloudRepList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getCloudRep${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createCloudRep = (data, token) => {
  return axios.post(`${baseUrl}/insertCloudRep`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const deleteCloudRep = (id, token) =>
  axios.delete(`${baseUrl}/deleteCloudRep/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateCloudRep = (id, data, token) =>
  axios.put(`${baseUrl}/updateCloudRep/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getCloudRepById = (id, token) =>
  axios.get(`${baseUrl}/getCloudRepbyID/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const getLeadsByCloudRepID = (query, id, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getLeadsByCloudRepID/${id}${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
